"use strict";

var _classCallCheck = require("/github/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/github/workspace/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var errors_1 = require("../errors");

var SESSION_VERSION = '1.0.0';
/**
 * @ignore
 */

var SessionData =
/*#__PURE__*/
function () {
  function SessionData(options) {
    _classCallCheck(this, SessionData);

    this.version = SESSION_VERSION;
    this.appPrivateKey = options.appPrivateKey;
    this.identityAddress = options.identityAddress;
    this.username = options.username;
    this.coreNode = options.coreNode;
    this.hubUrl = options.hubUrl;
    this.userData = options.userData;
    this.transitKey = options.transitKey;
  }

  _createClass(SessionData, [{
    key: "getGaiaHubConfig",
    value: function getGaiaHubConfig() {
      return this.userData && this.userData.gaiaHubConfig;
    }
  }, {
    key: "setGaiaHubConfig",
    value: function setGaiaHubConfig(config) {
      this.userData.gaiaHubConfig = config;
    }
  }, {
    key: "toString",
    value: function toString() {
      return JSON.stringify(this);
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(json) {
      if (json.version !== SESSION_VERSION) {
        throw new errors_1.InvalidStateError("JSON data version ".concat(json.version, " not supported by SessionData"));
      }

      var options = {
        appPrivateKey: json.appPrivateKey,
        identityAddress: json.identityAddress,
        username: json.username,
        coreNode: json.coreNode,
        hubUrl: json.hubUrl,
        userData: json.userData,
        transitKey: json.transitKey
      };
      return new SessionData(options);
    }
  }]);

  return SessionData;
}();

exports.SessionData = SessionData;